import { GAME_CONSTANTS } from '../config/gameConstants';
import { MARKET_FORMULAS } from '../config/gameFormulas';
import { roundToThousandths } from './numberFormatter';

export function calculateMonthlyRevenue(marketShare: number, reputation: number): number {
  const baseRevenue = MARKET_FORMULAS.getMarketValue(marketShare);
  const reputationMultiplier = roundToThousandths(1 + (reputation / 100));
  return Math.round(baseRevenue * reputationMultiplier);
}

export function calculateProfitMargin(revenue: number): number {
  const operationalCosts = MARKET_FORMULAS.getOperationalCost(revenue);
  const profit = revenue - operationalCosts;
  return Math.round((profit / revenue) * 100);
}

export function calculateMarketAppeal(techScore: number, price: number): number {
  const baseAppeal = techScore * GAME_CONSTANTS.business.techScoreWeight;
  const priceAppeal = (GAME_CONSTANTS.business.priceAppealDivisor / price) * GAME_CONSTANTS.business.priceAppealWeight;
  return Math.round(Math.min(100, baseAppeal + priceAppeal));
}

